export interface ModuleManual {
  prefix: string;
  title: string;
  file: string;
}

export const MODULE_MANUALS: ModuleManual[] = [
  { prefix: '/administration/users', title: 'Usuarios', file: '01_Manual_MatControl_Usuarios.pdf' },
  { prefix: '/modules', title: 'Módulos', file: '02_Manual_MatControl_Modulos.pdf' },
  { prefix: '/masters/articles', title: 'Creación de artículos', file: '03_Manual_MatControl_Articulos.pdf' },
  { prefix: '/masters/units', title: 'Unidad de medida', file: '04_Manual_MatControl_Unidades.pdf' },
  { prefix: '/masters/motivos', title: 'Motivos de movimientos', file: '05_Manual_MatControl_Motivos.pdf' },
  { prefix: '/masters/warehouse', title: 'Bodegas', file: '06_Manual_MatControl_Bodegas.pdf' },
  { prefix: '/masters/rubros', title: 'Rubros de almacén', file: '07_Manual_MatControl_Rubros.pdf' },
  { prefix: '/masters/formulas', title: 'Creación de fórmulas', file: '08_Manual_MatControl_Formulas.pdf' },
  { prefix: '/process/materiaP', title: 'Proceso materia prima', file: '09_Manual_MatControl_Proceso_Materia_Prima.pdf' },
  { prefix: '/process/materialE', title: 'Bodega de material de empaque', file: '10_Manual_MatControl_Proceso_Material_de_Empaque.pdf' },
  { prefix: '/process/mezclasl', title: 'Mezclas líquidas', file: '12_Manual_MatControl_Proceso_Mezclas_Liquidas.pdf' },
  { prefix: '/process/mezclas', title: 'Mezclas sólidas', file: '11_Manual_MatControl_Proceso_Mezclas_Solidas.pdf' },
  { prefix: '/sachetado', title: 'Proceso sachetado', file: '13_Manual_MatControl_Proceso_Sachetado.pdf' },
  { prefix: '/empaquetado', title: 'Proceso empaquetado', file: '14_Manual_MatControl_Proceso_Empaquetado.pdf' },
  { prefix: '/productot', title: 'Proceso producto terminado', file: '15_Manual_MatControl_Proceso_Producto_Terminado.pdf' },
  { prefix: '/process/calidad', title: 'Calidad y Cuarentena', file: '16_Manual_MatControl_Control_de_Calidad.pdf' },
  { prefix: '/reports', title: 'Reportes', file: '17_Manual_MatControl_Reportes.pdf' },
];

export const manualForPath = (path: string): ModuleManual | null => {
  const clean = path.split('?')[0];
  const ordered = [...MODULE_MANUALS].sort((a, b) => b.prefix.length - a.prefix.length);
  return ordered.find((item) => clean === item.prefix || clean.startsWith(`${item.prefix}/`)) ?? null;
};

export const manualUrl = (file: string) => `/manuales/${encodeURIComponent(file)}`;
